import proj1 from "../projects/proj1.jpg"
import proj2 from "../projects/proj2.jpg"
import proj3 from "../projects/proj3.jpg"
import proj4 from "../projects/proj4.jpg"
import proj5 from "../projects/proj5.jpg"
import proj6 from "../projects/proj6.jpg"
import proj7 from "../projects/proj7.jpg"

const ProjectsData = [
	{
		imgsrc: proj1,
		title: "File Transfer Protocol (FTP)",
		text: "Allows transfer of files between to PC connetected to a wired network.",
		github_url: "https://github.com/Zediogo96/RCOM_proj1",
	},
	{
		imgsrc: proj2,
		title: "Event Management Website",
		text: "Re-Event is a website that allows the creation of events and the management of the participants.",
		github_url: "https://github.com/Zediogo96/RE-Event",
	},
	{
		imgsrc: proj3,
		title: "Duck Hunt Game in Minix",
		text: "Clone of the classic game Duck Hunt, developed in C for the Minix operating system.",
		github_url: "https://github.com/Zediogo96/LCOM_Duck_Hunter",
	},
	{
		imgsrc: proj4,
		title: "Supaplex Game Clone",
		text: "Supaplex is a puzzle game developed in Java, using Lanterna.",
		github_url: "https://github.com/Zediogo96/Supapl0x-game",
	},
	{
		imgsrc: proj5,
		title: "Java-- Compiler",
		text: "Compiler for the Java-- language, which is a subset of the Java language.",
		github_url: "https://github.com/Zediogo96/FEUP_Comp_Java--",
	}, 
	{
		imgsrc: proj6,
		title: "Computer Graphics",
		text: "Development of a 3D consisting of a bird, trees, nests, eggs, etc, using webGL.",
		github_url: "https://github.com/Zediogo96/FEUP_CG/tree/master"
	},
	{
		imgsrc: proj7,
		title: "Distributed Systems",
		text: "Development of a distributed system for a simple online gaming Server, using Java, Sockets and NIO API.",
		github_url: "https://github.com/Zediogo96/FEUP_CPD"
	},
];

export default ProjectsData;
